import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { MarkFileRequestModel } from "../../kymw1502/vo/mark-file-request.model";

@Injectable()
export class RegistMarkFilePeriodService extends PlessJsonResponderSub<any> {
  // VO
  vo = {
    MarkCode: '',
    MarkCodeBranch: '',
    StartOrderCode: '',
    EndOrderCode: '',
  };

  // 処理に使用するModel
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistMarkFileService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        Rec: {
          condition: {
            MarkCode: this.vo.MarkCode,
            MarkCodeBranch: this.vo.MarkCodeBranch,
            StartOrderCode: this.vo.StartOrderCode,
            EndOrderCode: this.vo.EndOrderCode,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistMarkFilePeriodService
   */
  execute(vo: MarkFileRequestModel, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registMarkFilePeriod', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistMarkFilePeriodService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
